/**
 * @generated SignedSource<<22315a3605ed4964e010921738ac1e90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateDocumentInput = {
  byteSize: number;
  category?: string | null | undefined;
  contentType: string;
  description?: string | null | undefined;
  name: string;
  objectKey: string;
  organizationId?: string | null | undefined;
  systemId?: string | null | undefined;
};
export type useDocumentMutationsCreateMutation$variables = {
  input: CreateDocumentInput;
};
export type useDocumentMutationsCreateMutation$data = {
  readonly createDocument: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
    }>;
    readonly result: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  };
};
export type useDocumentMutationsCreateMutation = {
  response: useDocumentMutationsCreateMutation$data;
  variables: useDocumentMutationsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDocumentResult",
    "kind": "LinkedField",
    "name": "createDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDocumentMutationsCreateMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDocumentMutationsCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f9e454135b3cb7554bae7033c3ef91fe",
    "id": null,
    "metadata": {},
    "name": "useDocumentMutationsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useDocumentMutationsCreateMutation(\n  $input: CreateDocumentInput!\n) {\n  createDocument(input: $input) {\n    errors {\n      code\n      fields\n      message\n      shortMessage\n    }\n    result {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "95e72b0a33f03283b50700343f5ef2dd";

export default node;
